import { createSelector } from 'reselect';

import { TRootState } from '@/redux/rootReducer';
import { IDay } from '@/services/types/core/locations/id';
import { mapDateToWeekDay, mapTimeToIntervals, MAX_TIME } from '@/utility/time';

export const getWeekdayInfo = createSelector<
  TRootState,
  TRootState['dealerLocation'],
  TRootState['checkout']['booking'],
  IDay | undefined
>(
  state => state.dealerLocation,
  state => state.checkout.booking,
  (dealerLocation, booking) => {
    if (!dealerLocation || !booking) {
      return undefined;
    }

    const weekDay = mapDateToWeekDay(booking.from);

    // @ts-expect-error fixable: unchecked index access
    return dealerLocation.data?.availability?.days?.[weekDay];
  },
);

export const getDealerLocationPickupOptions = createSelector<
  TRootState,
  IDay | undefined,
  number[]
>(getWeekdayInfo, weekDayInfo => {
  const pickup = weekDayInfo?.pickup;

  if (!pickup || pickup.unavailable) {
    return mapTimeToIntervals(0, MAX_TIME);
  }

  return mapTimeToIntervals(pickup.start_time, pickup.end_time);
});

export const getDealerLocationDropoffOptions = createSelector<
  TRootState,
  IDay | undefined,
  number[]
>(getWeekdayInfo, weekDayInfo => {
  const dropoff = weekDayInfo?.dropoff;

  if (!dropoff || dropoff.unavailable) {
    return mapTimeToIntervals(0, MAX_TIME);
  }

  return mapTimeToIntervals(dropoff.start_time, dropoff.end_time);
});
